import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Breadcrumb/breadcrumb';
import { css } from '@patternfly/react-styles';
import { getOUIAProps } from '../../helpers';
export var Breadcrumb = function Breadcrumb(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$ariaLabel = _a['aria-label'],
      ariaLabel = _a$ariaLabel === void 0 ? 'Breadcrumb' : _a$ariaLabel,
      ouiaId = _a.ouiaId,
      props = __rest(_a, ["children", "className", 'aria-label', "ouiaId"]);

  return React.createElement("nav", Object.assign({}, props, {
    "aria-label": ariaLabel,
    className: css(styles.breadcrumb, className)
  }, getOUIAProps('Breadcrumb', ouiaId)), React.createElement("ol", {
    className: css(styles.breadcrumbList)
  }, children));
};